module.exports = __webpack_public_path__ + "static/media/pyDataDelhiLogo.4dc8c44e.png";